module.exports = __webpack_public_path__ + "img/365653833956649_thumbnail.jpg";